import { get, some } from 'es-toolkit/compat';
var ignoreErrorMessages = ['Invariant: attempted to hard navigate to the same URL'];
var levels = ['fatal', 'error'];

/**
 * 에러 수집 필터링
 */
export function ignoreSentryEvent(event) {
  var _event$exception, _event$exception$valu;
  if (!levels.includes(event.level || '')) {
    return true;
  }
  var errorValue = get(event, ['exception', 'values', 0, 'value']) || '';
  return ((_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : (_event$exception$valu = _event$exception.values) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu.length) === 1 && some(ignoreErrorMessages, function (message) {
    return errorValue.startsWith(message);
  });
}